import { Injectable } from '@angular/core';

import {
    recursiveSearchToFlat, flatSearchToRecursive, SearchParams, FieldMode,
    FlatSearchParams, fieldType, getSelectTypeFields, evaluateDependencies, Workflow, convertDependency
} from '@azavista/advanced-search';
import { Field, FieldType } from '@azavista/advanced-search/lib/field-types';

import { IDependency, IField } from './interfaces';
import { IActivityList } from '@azavista/activity-lib';
import { CartItem, Product } from '@azavista/payments';
import { ShoppingCartResultUI } from '@azavista/payments/lib/shopping-cart/processor-ui';
import { EventSettings } from '@azavista/advanced-search/lib/search-types';

@Injectable({
    providedIn: 'root'
})
export class AdvancedSearchLibService {
    evaluateDependencies(
        dependencies: IDependency[],
        participant: Record<string, any>,
        event: Record<string, any>,
        participantActivities: IActivityList[],
        shoppingCartResult: ShoppingCartResultUI,
        workflow: Workflow,
        eventSettings: EventSettings,
    ): Record<string, boolean> {
        const convertedDependencies = dependencies.map(dep => convertDependency(dep));
        const evaluateResult = evaluateDependencies(
            // TODO: operator const enums od IDependency.criteria and DependencyV2.criteria are considered not equal to typescript (event though they have same member names with same values)
            convertedDependencies,
            participant,
            event,
            participantActivities,
            shoppingCartResult,
            workflow,
            eventSettings
        );
        return evaluateResult;
    }

    getSelectAndMultiSelectFields(fields: IField[]): IField[] {
        return getSelectTypeFields(fields as Field[]) as IField[];
    }

    getFieldTypeFromField(field: IField): FieldType {
        return fieldType(field as Field);
    }

    convertFlatSearchToRecursive(flatSearchParams: FlatSearchParams, fieldMode: FieldMode): SearchParams {
        return flatSearchToRecursive(flatSearchParams, fieldMode);
    }

    convertRecursiveSearchToFlat(searchParams: SearchParams, fieldMode: FieldMode, fields: Field[]): FlatSearchParams {
        return recursiveSearchToFlat(searchParams, fieldMode, fields);
    }
}
